import { createApi } from '@reduxjs/toolkit/query/react'
import baseQueryWithReauth from './baseQueryWithReauth';

// Define a service using a base URL and expected endpoints
export const enumApi = createApi({
  reducerPath: 'enumApi',  
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    uploadType: builder.query<any, void>({
      query: () => 'enum/uploadType',
    }),
    paperSizes: builder.query<any, void>({
      query: () => `enum/paperSizes`,
    }),
    boreholeStatuses: builder.query<any, void>({
      query: () => `enum/boreholeStatuses`,
    }),
    templateLevels: builder.query<any, boolean>({      
      query: (forView) => `enum/templateLevels/${forView}`,
      transformResponse: (response: any) => response.templateLevels || response,
    }),
    curveTypes: builder.query<any, void>({
      query: () => `enum/curveTypes`,
    }),
    templateTrackTypes: builder.query<any, void>({
      query: () => `enum/templateTrackTypes`,
    }),
    averagingTypes: builder.query<any, void>({
      query: () => `enum/averagingTypes`,
    }),
    clientPriority: builder.query<any, void>({
      query: () => `enum/ClientPriority`,
    })
  }) 
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useUploadTypeQuery, 
               usePaperSizesQuery, 
               useBoreholeStatusesQuery,
               useTemplateLevelsQuery,
               useCurveTypesQuery,
               useTemplateTrackTypesQuery,
               useAveragingTypesQuery,
               useClientPriorityQuery } = enumApi;